'use strict';

export default function lazyloadSlider($slider = [], idx = 0, slideSelector = '.slick-slide') {
    const BG_ATTR = 'data-bg',
        IMG_ATTR = 'data-src',
        LOADED_IMG_CLASS = 'lazy-loaded';

    if ($slider.length) {
        let $slide = $slider.find(`${slideSelector}[data-slick-index="${idx}"]`);

        if ($slide.length) {
            let $bgHld = $slide.find(`[${BG_ATTR}]`),
                $imgHld = $slide.find(`[${IMG_ATTR}]`),
                src;

            if ($bgHld.length && (src = $bgHld.attr(BG_ATTR))) {
                $bgHld
                    .css('background-image', `url(${src})`)
                    .removeAttr(BG_ATTR)
                    .addClass(LOADED_IMG_CLASS);
            }

            if ($imgHld.length && (src = $imgHld.attr(IMG_ATTR))) {
                $imgHld
                    .attr('src', src)
                    .removeAttr(IMG_ATTR);
            }
        }
    }
}
